import React from 'react';
import { IconProps } from './types';

export const ThemeDarkIcon = (props: IconProps) => {
  const { size = 16, color = 'currentColor', style = {} } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
    >
      <path
        fill={color}
        d='M12.1 21.9h-1c-5.5-.6-9.5-5.4-9-10.9.4-4.8 4.2-8.6 9-9 .4 0 .8.2 1 .5.2.3.2.8-.1 1.1-.9 1.3-1.3 2.9-1.1 4.5.2 1.6 1.1 3 2.4 3.9 2.2 1.6 5 1.6 7.1 0 .3-.2.7-.3 1.1-.1.3.2.5.6.5 1-.5 5.2-4.9 9-9.9 9zM9.3 4.4c-2.8 1-4.9 3.6-5.2 6.8-.4 4.4 2.8 8.3 7.2 8.7 3.7.4 7-1.9 8.2-5.2-2.5.9-5.2.5-7.4-1.1-1.7-1.3-2.9-3.1-3.2-5.3-.2-1.3 0-2.6.4-3.9z'
      />
    </svg>
  );
};
